import { DisplaySlot } from 'generated/graphql';
import { atom } from 'recoil';
import { broadcastChannelSynchronizerEffect } from 'utils/recoilEffects';

interface WorkspaceDisplayArrangement {
  displays: DisplaySlot[];
}
export const workspaceDisplayArrangementState = atom<WorkspaceDisplayArrangement | null>({
  key: 'workspaceDisplayArrangement',
  default: null,
  effects: [broadcastChannelSynchronizerEffect()],
});

export interface ActiveWorkspaceLayoutPreset {
  presetId: string;
  // The monitor setup the user picked it on; the pick holds there, other setups use their default
  displayArrangementKey: string;
  // Set when the user picks a layout, so the auto-apply owner applies it (again, if re-picked)
  requestedAt?: number;
}

export const activeWorkspaceLayoutPresetState = atom<ActiveWorkspaceLayoutPreset | null>({
  key: 'activeWorkspaceLayoutPreset',
  default: null,
  effects: [broadcastChannelSynchronizerEffect()],
});
